import { render, staticRenderFns } from "./gradeClassStudent.vue?vue&type=template&id=4c0f773e&scoped=true&"
import script from "./gradeClassStudent.vue?vue&type=script&lang=js&"
export * from "./gradeClassStudent.vue?vue&type=script&lang=js&"
import style0 from "./gradeClassStudent.vue?vue&type=style&index=0&id=4c0f773e&prod&lang=less&scoped=true&"
import style1 from "./gradeClassStudent.vue?vue&type=style&index=1&id=4c0f773e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f773e",
  null
  
)

export default component.exports